import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import StudentInstructorService from "../../services/student-instructor.service";
import { PaginationParamsType } from "../../types/common";

// get students for instructor
export const getStudentsFromApi: any = createAsyncThunk(
  "studentInstructor/getStudents",
  async (params: PaginationParamsType) => {
    if (!params) params = { page: 1, per_page: 1000, query: "" };
    const res: any = await StudentInstructorService.getStudents(params);
    if (res?.response?.status >= 400) {
      throw new Error(res?.response?.data?.error);
    }
    return res;
  }
);

// get instructors for student
export const getInstructorsFromApi: any = createAsyncThunk(
  "studentInstructor/getInstructors",
  async (params: PaginationParamsType) => {
    if (!params) params = { page: 1, per_page: 1000, query: "" };
    const res: any = await StudentInstructorService.getInstructors(params);
    if (res?.response?.status >= 400) {
      throw new Error(res?.response?.data?.error);
    }
    return res;
  }
);

const initialState: any = {
  students: [],
  instructors: [],
  totalCount: 0,
  status: "idle",
  error: null,
};

export const instructorStudentSlice = createSlice({
  name: "studentInstructor",
  initialState,
  reducers: {
    setStatusForStudentInstructor: (state, action) => {
      state.status = action.payload;
    },
    setStudentsList: (state, action) => {
      state.students = action.payload;
    },
    setInstructorsList: (state, action) => {
      state.instructors = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Get Students List For Instructors
    builder.addCase(getStudentsFromApi.pending, (state, action) => {
      state.status = "loading";
    });
    builder.addCase(getStudentsFromApi.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.students = Array.isArray(
        action.payload?.students?.studentInstructors
      )
        ? [...state.students, ...action.payload?.students?.studentInstructors]
        : state.students;
      state.totalCount = action.payload?.totalCount || 0;
    });
    builder.addCase(getStudentsFromApi.rejected, (state, action) => {
      state.status = "failed";
      state.error = action?.error?.message || "Something went wrong";
    });

    // Get Instructors List For Students
    builder.addCase(getInstructorsFromApi.pending, (state, action) => {
      state.status = "loading";
    });
    builder.addCase(getInstructorsFromApi.fulfilled, (state, action) => {
      state.status = "succeeded";
      state.instructors = Array.isArray(
        action.payload?.instructors?.studentInstructors
      )
        ? [
            ...state.instructors,
            ...action.payload?.instructors?.studentInstructors,
          ]
        : state.instructors;
      state.totalCount = action.payload?.totalCount || 0;
    });
    builder.addCase(getInstructorsFromApi.rejected, (state, action) => {
      state.status = "failed";
      state.error = action?.error?.message || "Something went wrong";
    });
  },
});

export const {
  setStatusForStudentInstructor,
  setStudentsList,
  setInstructorsList,
} = instructorStudentSlice.actions;

export const getInstructors = (state: RootState) =>
  state.studentInstructor.instructors;

export const getStudentInstructorsTotalCount = (state: RootState) =>
  state.studentInstructor.totalCount;

export const getStudents = (state: RootState) =>
  state.studentInstructor.students;

export const getUserApiStatus = (state: RootState) =>
  state.studentInstructor.status;

export default instructorStudentSlice.reducer;
